import React, { createContext, useContext, useState, useCallback } from 'react';

interface LoadingContextType {
  isLoading: boolean;
}

const LoadingContext = createContext<LoadingContextType>({ isLoading: false });

// Module-level refs so Axios interceptors can call these outside of React
let _increment: (() => void) | null = null;
let _decrement: (() => void) | null = null;

export const globalLoading = {
  increment: () => _increment?.(),
  decrement: () => _decrement?.(),
};

export function LoadingProvider({ children }: { children: React.ReactNode }) {
  const [count, setCount] = useState(0);

  const increment = useCallback(() => setCount((c) => c + 1), []);
  const decrement = useCallback(() => setCount((c) => Math.max(0, c - 1)), []);

  _increment = increment;
  _decrement = decrement;

  return (
    <LoadingContext.Provider value={{ isLoading: count > 0 }}>
      {children}
    </LoadingContext.Provider>
  );
}

export function useLoading() {
  return useContext(LoadingContext);
}
